import { default as angular } from "angular";
import uiRouter from "@uirouter/angularjs/lib-esm";

import { moduleName as recordsModuleName } from "../records";
import { routeConfig } from "./routes";

import {
  vsName as MachineDetailContractComponentName,
  machineDetailContractComponentOptions,
} from "./views/info";
import {
  vsComponentName as MachineDetailContractEditComponentName,
  MachineDetailContractEditComponentOptions,
} from "./views/edit";

import {
  vsComponentName as MachineDetailMachinesEditComponentName,
  MachineDetailMachinesEditComponentOptions,
} from "./views/machines/edit";

import {
  vsComponentName as MachineDetailMachinesViewComponentName,
  MachineDetailMachinesViewComponentOptions,
} from "./views/machines";

import {
  vsComponentName as ContractDetailProcessViewComponentName,
  ContractDetailProcessViewComponentOptions,
} from "./views/process";

import {
  vsComponentName as ProcessTemplateComponentName,
  ProcessTemplateComponentOptions,
} from "./views/template";

import {
  vsComponentName as ProcessTemplateEditComponentName,
  ProcessTemplateEditComponentOptions,
} from "./views/template/edit";

import {
  SelectContractModalService,
  vsServiceName as selectContractModalServiceName,
  selectContractModalComponentOptions,
  vsComponentName as SelectContractModalComponentOptionsName,
} from "./shared/components/selectContractModal";
import { vsModuleName as configModuleName } from "./configs/module";

export const vsName = "SlotTrak.Contract";

angular
  .module(vsName, [uiRouter, recordsModuleName, configModuleName, "ui.tinymce"])
  .config(routeConfig)
  .component(
    MachineDetailContractComponentName,
    machineDetailContractComponentOptions
  )
  .component(
    MachineDetailContractEditComponentName,
    MachineDetailContractEditComponentOptions
  )
  .component(
    MachineDetailMachinesEditComponentName,
    MachineDetailMachinesEditComponentOptions
  )

  .component(
    MachineDetailMachinesViewComponentName,
    MachineDetailMachinesViewComponentOptions
  )
  .component(
    ContractDetailProcessViewComponentName,
    ContractDetailProcessViewComponentOptions
  )
  .component(
    ProcessTemplateComponentName,
    ProcessTemplateComponentOptions
  )
  .component(
    ProcessTemplateEditComponentName,
    ProcessTemplateEditComponentOptions
  )
  .service(selectContractModalServiceName, SelectContractModalService)
  .component(
    SelectContractModalComponentOptionsName,
    selectContractModalComponentOptions
  );

export default vsName;
